/**
 * Mock-quiz success screen.
 */
import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Link, useParams } from "react-router-dom";

import { getModuleIndexOfSection, getPrevNextLinks, getSectionTitle } from "utils/course";
import { useAsterController } from "context";
import { VButton, VImage } from "form";
import { BBadge } from "components";

/**
 * Celebrates a passed quiz and shows the earned badge.
 *
 * @param {{ onContinue?: Function }} props
 */
const QuizSuccess = (props) => {

  const { onRestartClick } = props;

  const { t } = useTranslation('common');

  const { courseId, sectionIndex, sequenceIndex, verticalIndex } = useParams();

  const [controller] = useAsterController();
  const { structure: courseStructure, themes, preview } = controller;

  const [nextLink, setNextLink] = useState(null);
  const [moduleIndex, setModuleIndex] = useState(null);
  const [sectionTitle, setSectionTitle] = useState(null);

  useEffect(() => (nextLink && courseStructure && Object.keys(courseStructure).length) && setSectionTitle(getSectionTitle(courseStructure, nextLink.split('/')[0])), [courseStructure, nextLink]);

  useEffect(() => {
    const moduleIdx = getModuleIndexOfSection(courseStructure, sectionIndex);
    setModuleIndex(moduleIdx);
  }, [sectionIndex, courseStructure]);

  useEffect(() => {
    const { next } = getPrevNextLinks(courseStructure, sectionIndex, sequenceIndex, verticalIndex);
    setNextLink(next.route);
  }, [courseStructure, sectionIndex, sequenceIndex, verticalIndex]);

  return <>
    <div className="w-full">
      <div className="shadow mt-5 p-4 overflow-hidden position-relative">
        <div id="stars"></div>
        <div id="stars2"></div>
        <div id="stars3"></div>
        <div className="flex items-center flex-col w-full">
          {
            moduleIndex && <>
              <BBadge index={Number(moduleIndex)} className="w-36" />
              <VImage src={(themes || []).find(t => t.name === `badge${moduleIndex}_url`)?.value} className="w-36 h-36" />
              <p className="font-bold fsp-18 text-muted mt-4">
                {t('Well done! You have succeeded and earned the module')}&nbsp;
                {moduleIndex}&nbsp;!
              </p>
              <div className="flex">
                <VButton onClick={onRestartClick} variant="contained">
                  {t('Start the quiz again')}
                </VButton>
                <Link to={`/${preview ? 'preview' : 'content'}/${courseId}/${nextLink}`} className="no-underline ml-4">
                  <VButton variant="contained">
                    {t('Start')}&nbsp;{sectionTitle}
                  </VButton>
                </Link>
              </div>
            </>
          }
        </div>
      </div>

    </div>
  </>;
};

export default QuizSuccess;